import { Label } from '../../types/label'
import { formatNumber } from '../../utils'
import styles from './Labels.module.css'

interface LabelGridProps {
  labels: Label[]
  onLabelClick?: (label: Label) => void
}

export function LabelGrid({ labels, onLabelClick }: LabelGridProps) {
  return (
    <div className={styles.labelGrid}>
      {labels.map(label => (
        <LabelCard
          key={`label-${label.name}`}
          label={label}
          onClick={onLabelClick}
        />
      ))}
    </div>
  )
}

interface LabelCardProps {
  label: Label
  onClick?: (label: Label) => void
}

function LabelCard({ label, onClick }: LabelCardProps) {
  return (
    <div className={styles.labelCard} onClick={() => onClick?.(label)}>
      <div className={styles.labelAvatar}>
        {label.cover_image ? (
          <img src={label.cover_image} alt={label.name} />
        ) : (
          <div className={styles.labelNoImage}>
            <i className="bi bi-tag-fill"></i>
          </div>
        )}
      </div>

      <div className={styles.labelContent}>
        <div className={styles.labelName}>{label.name}</div>
        <div className={styles.labelMeta}>
          {formatNumber(label.release_count)} release{label.release_count !== 1 ? 's' : ''}
        </div>
      </div>
    </div>
  )
}
